const GEO_OPTIONS = { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 };

// Indoor high-accuracy fixes are the most common non-denial failure — retry cheap and slow.
export const GEO_RETRY_OPTIONS = { enableHighAccuracy: false, timeout: 30000 };

export const GEO_ERROR = {
  NO_API: 'no-api',
  PERMISSION_DENIED: 'permission-denied',
  UNAVAILABLE: 'unavailable',
  TIMEOUT: 'timeout',
};

const ERROR_BY_CODE = {
  1: GEO_ERROR.PERMISSION_DENIED,
  2: GEO_ERROR.UNAVAILABLE,
  3: GEO_ERROR.TIMEOUT,
};

export const getKioskGeolocation = (options) =>
  new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
      return resolve({ error: GEO_ERROR.NO_API });
    }
    const settings = { ...GEO_OPTIONS, ...options };
    let settled = false;
    let guard;

    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(guard);
      resolve(result);
    };

    // Some browsers call neither callback when the OS blocks location — this keeps the promise settling.
    guard = setTimeout(() => finish({ error: GEO_ERROR.TIMEOUT }), settings.timeout + 2000);

    navigator.geolocation.getCurrentPosition(
      ({ coords }) =>
        finish({
          latitude: coords.latitude,
          longitude: coords.longitude,
          accuracy: coords.accuracy,
        }),
      (err) => finish({ error: ERROR_BY_CODE[err.code] || GEO_ERROR.UNAVAILABLE }),
      settings
    );
  });

export const isGeoSuccess = (result) => result && !result.error;

// navigator.permissions is absent/unreliable on iOS Safari — never let it throw.
export const getGeolocationPermissionState = async () => {
  try {
    const status = await navigator.permissions.query({ name: 'geolocation' });
    return status.state;
  } catch (e) {
    return 'unknown';
  }
};

export const subscribeToPermissionChange = (onChange) => {
  let cancelled = false;
  let unsubscribe = () => null;

  try {
    navigator.permissions.query({ name: 'geolocation' }).then((status) => {
      if (cancelled) return;
      const handle = () => onChange(status.state);
      status.addEventListener('change', handle);
      unsubscribe = () => status.removeEventListener('change', handle);
    }, () => null);
  } catch (e) {
    return () => null;
  }

  return () => {
    cancelled = true;
    unsubscribe();
  };
};
